module.exports = __webpack_public_path__ + "static/media/top-venues-video.1d444f91.mp4";